module.exports = __webpack_public_path__ + "static/media/message_received_sound.8b03400.mp3";


//////////////////
// WEBPACK FOOTER
// ./static/sounds/message_received_sound.mp3
// module id = 406
// module chunks = 1